import alarmReducer from '@sophocles/features/alarms/slice';

export default alarmReducer;
export { alarmReducer };
